import React from 'react';
import { useIntl } from 'react-intl';
import { cdnImage } from '@/utils/image-utils';
import LoadingSpinner from '@/components/shared/spinner/LoadingSpinner';

const IdScanProcessing = () => {
  const intl = useIntl();

  return (
    <div data-cy="id-scan-progress-text" className="flex flex-col items-center text-center gap-y-4">
      <img
        src={cdnImage('sitting-cat.png', {
          width: '160',
          height: '160',
          fit: 'scale-down',
        })}
        alt="Lucky Cat"
      />
      <h3 className="m-0">{intl.formatMessage({ id: 'id-scan-modal.process-title' })}</h3>
      <p className="m-0">{intl.formatMessage({ id: 'id-scan-modal.process-text' })}</p>
      <LoadingSpinner mode="dark" />
    </div>
  );
};

export default IdScanProcessing;
